<template>
    <div class="doc-hub-version-text">
        <div class="d-flex justify-content-start gap-3 align-items-baseline">
            <div class="font-size-70 text-muted font-weight-500 text-uppercase">Version {{ version.version_number }}</div>
            <div class="font-size-70 text-muted font-weight-500">{{ formatDate(version.created) }}</div>
        </div>
        <div
            v-if="version.version_notes" 
            class="text-show-breaks font-size-80">{{ version.version_notes }}</div>
    </div>
</template>

<script>
import { FormatDateHelper } from '@/js/filters-helpers';

export default {
    name: 'DocHubVersionText',
    components: {},
    mixins: [],
    props: {
        version: {
            type: Object,
            required: true,
        },
    },
    methods: {
        formatDate(dateString) {
            return FormatDateHelper(dateString);
        },
    },
}
</script>

<style lang="scss" scoped>
</style>